import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Modal } from "@shared/components";
import { PlanFormProduct } from "./PlanFormProduct";
import { useParams } from "react-router";
import { ProductPlanFormValues } from "@modules/defaultProducts/types";
import { createProductPlanService } from "@modules/defaultProducts/services/mutations/createProductPlan";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";
import { masks } from "@core/utils/masks";

type CreateProductPlanModalProps = {
  modalRef: React.Ref<any>;
  onSave: (data: any) => void;
};

export function CreateProductPlanModal({
  modalRef,
  onSave,
}: CreateProductPlanModalProps) {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const { open } = useNotification();

  const methods = useForm<ProductPlanFormValues>({
    defaultValues: {
      id: undefined,
      name: "",
      value: "",
      description: "",
      default_product: id ? parseInt(id) : 0,
      level: 0,
      vindi_page: "",
      vindi_token: "",
    },
    mode: "onBlur",
  });

  const createPlanMutation = useMutation({
    mutationFn: createProductPlanService,
    onSuccess: () => {
      open?.({
        type: "success",
        message: "Plano criado com sucesso!",
      });
      queryClient.invalidateQueries({ queryKey: ["default_plan_admin"] });
      onSave({});
      methods.reset();
      (modalRef as React.MutableRefObject<any>).current?.close();
    },
    onError: (error) => {
      console.error("Erro ao criar plano:", error);
      open?.({
        type: "error",
        message: "Erro ao criar plano. Tente novamente.",
      });
    },
  });

  const handleConfirm = async () => {
    const values = methods.getValues();

    values.value = values.value
      ? String(Number(masks.unmask(values.value)) / 100)
      : "0";

    values.default_product = id ? parseInt(id) : 0;
    createPlanMutation.mutate(values);
  };

  return (
    <Modal
      ref={modalRef as any}
      title={"Criar Plano"}
      onConfirm={handleConfirm}
      methods={methods}
      isPending={createPlanMutation.isPending}
    >
      <FormProvider {...methods}>
        <PlanFormProduct productId={!!id} />
      </FormProvider>
    </Modal>
  );
}
